module.exports = __webpack_public_path__ + "af122dad64cc32bc998ee05bf89301f5.png";


//////////////////
// WEBPACK FOOTER
// ./Res/3rd/avec/img/empty_img.png
// module id = 2583
// module chunks = 1